import React from 'react';

import { colors } from '@/globalStyles';

const DownloadIcon = props => {
  const { width = 24, height = 24, color = colors.white } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.703 15.463a.373.373 0 0 0 .298.138.447.447 0 0 0 .299-.114l4.05-3.6a.45.45 0 1 0-.598-.673L12.45 14.15V5.252a.45.45 0 0 0-.9 0v8.899l-3.302-2.937a.45.45 0 0 0-.636.04.421.421 0 0 0 .04.61l4.05 3.6zm5.698-1.662h-1.35a.45.45 0 1 0 0 .9h1.35a.9.9 0 0 1 .9.9v1.8a.9.9 0 0 1-.9.9H6.6a.9.9 0 0 1-.9-.9v-1.8a.9.9 0 0 1 .9-.9h1.35c.247 0 .45-.203.45-.45a.451.451 0 0 0-.45-.45H6.6a1.8 1.8 0 0 0-1.8 1.8v1.8a1.8 1.8 0 0 0 1.8 1.8h10.8a1.8 1.8 0 0 0 1.8-1.8v-1.8c0-.993-.807-1.8-1.8-1.8zm-.225 2.7a.675.675 0 1 0-1.35 0 .675.675 0 0 0 1.35 0z"
        fill={color}
      />
    </svg>
  );
};

export default DownloadIcon;
